import { useMemo } from 'react';
import {
  useGetCollectionTicketClaims,
  useListCollectionImports,
} from '@/api/trafikportalen';
import type { FormattedStudent } from '@/types/students';

export const useStudentCategoryEmpty = (
  collectionId: string | null,
  students: FormattedStudent[] | undefined,
) => {
  const { data: ticketClaims, isLoading: isLoadingClaims } =
    useGetCollectionTicketClaims(collectionId ?? '', {
      query: { enabled: !!collectionId },
    });

  const { data: imports, isLoading: isLoadingImports } =
    useListCollectionImports(collectionId ?? '', {
      query: { enabled: !!collectionId },
    });

  const isEmpty = useMemo(() => {
    if (!collectionId || isLoadingClaims || isLoadingImports) return false;

    const noPeriods = !ticketClaims || ticketClaims.length === 0;
    const noImports = !imports || imports.length === 0;
    const noStudents = !students || students.length === 0;

    return noPeriods && noImports && noStudents;
  }, [
    collectionId,
    ticketClaims,
    imports,
    students,
    isLoadingClaims,
    isLoadingImports,
  ]);

  return isEmpty;
};
